export const GET_CURRENCIES_REQUESTED = 'GET_CURRENCIES_REQUESTED';
export const GET_CURRENCIES_SUCCEEDED = 'GET_CURRENCIES_SUCCEEDED';
export const GET_CURRENCIES_FAILED = 'GET_CURRENCIES_FAILED';

export const SET_CURRENCY_CODE_REQUESTED = 'SET_CURRENCY_CODE_REQUESTED';
export const SET_CURRENCY_CODE_SUCCEEDED = 'SET_CURRENCY_CODE_SUCCEEDED';
export const SET_CURRENCY_CODE_FAILED = 'SET_CURRENCY_CODE_FAILED';
